import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { auditTrailService } from '../../../lib/auditTrailService';

const AdminActionsPanel = ({ onRefresh }) => {
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAdminActions();
  }, []);

  const loadAdminActions = async () => {
    setLoading(true);
    try {
      const { data } = await auditTrailService?.getAdminActions({ limit: 50 });
      setActions(data || []);
    } catch (error) {
      console.error('Error loading admin actions:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Admin Actions</h3>
        <span className="text-sm text-muted-foreground">{actions?.length || 0} actions</span>
      </div>
      <div className="space-y-3">
        {loading ? (
          <div className="text-center py-12">
            <Icon name="Loader" size={32} className="animate-spin text-primary mx-auto" />
          </div>
        ) : actions?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="UserCheck" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No admin actions recorded</p>
          </div>
        ) : (
          actions?.map((action) => (
            <div key={action?.id} className="p-4 bg-muted/30 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="UserCheck" size={20} className="text-primary" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="text-sm font-medium text-foreground">{action?.event_action}</h4>
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-info/15 text-info">
                      {action?.event_category}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{action?.event_description}</p>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {action?.user?.full_name || 'System'}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {new Date(action?.created_at)?.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminActionsPanel;